export const formatNumber = (value) => {
    const number = Number(value);
    return Intl.NumberFormat("en-US").format(number);
};
export const isTruthy = (x) => !!x;
export const getImageUrl = (imageId) => `https://vsco.co/i/${imageId}`;
export const replaceInnerText = (id, value) => {
    const el = document.getElementById(id);
    try {
        el.innerText = value;
    }
    catch (e) { }
};
export const shouldLog = () => {
    if (window && "captureLogger" in window && window.captureLogger) {
        return true;
    }
    return false;
};
export const hideUsernameTab = () => {
    const tabUser = document.getElementById("tab-user");
    if (tabUser) {
        tabUser.style.display = "none";
    }
};
